import React from "react";
import { Background, BackgroundVariant, Controls, ReactFlow } from "reactflow";
import type { Edge, Node, ConnectionMode } from "reactflow";
import type { EdgeData, NodeData } from "../../lib/api";
import { Spinner } from "../Spinner";

type CanvasProps = {
  nodes: Node<NodeData>[];
  edges: Edge<EdgeData>[];
  nodeTypes: any;
  edgeTypes: any;
  onNodesChange: any;
  onEdgesChange: any;
  onConnect: any;
  onSelectionChange: any;
  onNodeClick: (node: Node<NodeData>) => void;
  viewOnly: boolean;
  theme: "light" | "dark";
  loading: boolean;
  pngExporting: boolean;
  flowWrapperRef: React.RefObject<HTMLDivElement>;
  fitView?: boolean;
  onEmptySelection?: () => void;
};

export function Canvas({
  nodes,
  edges,
  nodeTypes,
  edgeTypes,
  onNodesChange,
  onEdgesChange,
  onConnect,
  onSelectionChange,
  onNodeClick,
  viewOnly,
  theme,
  loading,
  pngExporting,
  flowWrapperRef,
  fitView = true,
}: CanvasProps) {
  return (
    <div className={`flex-1 relative bg-[var(--color-canvas)] ${pngExporting ? "is-exporting" : ""}`} ref={flowWrapperRef}>
      {loading ? (
        <div className="absolute inset-0 flex items-center justify-center text-slate-500">
          <Spinner label="Lade Graph..." size="lg" />
        </div>
      ) : (
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          connectionMode={"loose" as ConnectionMode}
          isValidConnection={() => true}
          fitView={fitView}
          minZoom={0.1}
          maxZoom={4}
          zoomOnScroll={true}
          zoomOnPinch={true}
          zoomOnDoubleClick={true}
          panOnScroll={false}
          onSelectionChange={onSelectionChange}
          onNodeClick={(_, node) => onNodeClick(node as Node<NodeData>)}
          nodesDraggable={!viewOnly}
          nodesConnectable={!viewOnly}
          elementsSelectable={true}
          selectionOnDrag={!viewOnly}
          multiSelectionKeyCode={["Meta", "Control", "Shift"]}
          snapToGrid
          snapGrid={[16, 16]}
          panOnDrag
          onlyRenderVisibleElements
          proOptions={{ hideAttribution: true }}
        >
          <Background gap={24} size={1} variant={BackgroundVariant.Dots} color={theme === "dark" ? "#1e293b" : "#cbd5e1"} />
          <Controls />
        </ReactFlow>
      )}
    </div>
  );
}
